import { KickbackSource } from "../types/enums/KickbackSource";

const SOURCE_MONTH_OFFSET: Record<KickbackSource, number> = {
  [KickbackSource.VIVA]: -1,
  [KickbackSource.PAYTRIM]: -2,
  [KickbackSource.ELAVON]: -2,
};

const shiftPeriod = (period: string, months: number) => {
  const [year, month] = period.split("-").map(Number);
  const monthIndex = (year ?? 0) * 12 + (month ?? 1) - 1 + months;
  const shiftedYear = Math.floor(monthIndex / 12);
  const shiftedMonth = (monthIndex % 12) + 1;
  return `${shiftedYear}-${String(shiftedMonth).padStart(2, "0")}`;
};

/**
 * The month whose data a source contributes to an invoice period. The
 * invoice generated at the start of October has period 2026-10 (licenses
 * are billed to the end of October) and carries Viva for September.
 * Paytrim and Elavon report a month late, so it gets their August data.
 */
export const kickbackSourcePeriod = (
  invoicePeriod: string,
  source: KickbackSource,
) => shiftPeriod(invoicePeriod, SOURCE_MONTH_OFFSET[source]);
